import { createStyles, makeStyles } from '@material-ui/core/styles';
import { BLACK } from 'constants/colors';
export default makeStyles(theme => createStyles({
  summary: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'row'
  },
  backButton: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(8)
  },
  ad: {
    display: 'grid',
    gridTemplateColumns: '4fr 6fr',
    width: '100%',
    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      objectPosition: '50% 50%',
      overflow: 'hidden'
    },
    '& h3': {
      fontWeight: 'bold'
    },
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    minHeight: '250px',
    overflow: 'clip'
  },
  adText: {
    '& a': {
      color: BLACK
    }
  },
  adButtons: {
    '& a': {
      textDecoration: 'none',
      marginTop: theme.spacing(1.5),
      display: 'inline-block',
      paddingRight: theme.spacing(1),
      marginBottom: theme.spacing(1.5)
    }
  },
  adTextContainer: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    paddingTop: theme.spacing(1),
    [theme.breakpoints.up('md')]: {
      display: 'grid',
      gridTemplateRows: '70px 1fr 70px'
    }
  }
}));